import { Badge, Box, Button, CloseButton, Dialog, Flex, Portal, Table } from '@chakra-ui/react'
import { DataListComponent } from '@src/components/DataListComponent/DataListComponent'
import { IDataListProps } from '@src/components/DataListComponent/types'
import { lang } from '@src/lang'

interface Props {
    open: boolean
    setOpen: (value: boolean) => void
    title?: string
    data?: IDataListProps[]
    showTable?: boolean
    tableItems?: any[]
}

export const DialogComponent = (props: Props) => {
    return (
        <Dialog.Root lazyMount open={props.open} onOpenChange={e => props.setOpen(e.open)}>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header>
                            <Dialog.Title>{props.title}</Dialog.Title>
                        </Dialog.Header>
                        <Dialog.Body>
                            {props.data && (
                                <Box marginLeft={2}>
                                    <DataListComponent data={props.data}></DataListComponent>
                                </Box>
                            )}

                            {props.showTable && props.tableItems && (
                                <Table.Root
                                    variant={'line'}
                                    size={'sm'}
                                    showColumnBorder={true}
                                    marginTop={3}
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.ColumnHeader>Класс</Table.ColumnHeader>
                                            <Table.ColumnHeader>Объем</Table.ColumnHeader>
                                            <Table.ColumnHeader>Масса</Table.ColumnHeader>
                                            <Table.ColumnHeader>Площадь</Table.ColumnHeader>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {props.tableItems.map(item => (
                                            <Table.Row key={item.id}>
                                                <Table.Cell>{item.name}</Table.Cell>
                                                <Table.Cell>{item.volume}</Table.Cell>
                                                <Table.Cell>{item.mass}</Table.Cell>
                                                <Table.Cell>{item.area}</Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table.Root>
                            )}
                        </Dialog.Body>
                        <Dialog.Footer>
                            <Dialog.ActionTrigger asChild>
                                <Button variant="outline">{lang.close}</Button>
                            </Dialog.ActionTrigger>
                        </Dialog.Footer>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    )
}
